import Game from './game.container';

export default Game;



// WEBPACK FOOTER //
// ./src/game/index.js